import {Component, Input, OnInit} from '@angular/core';
import {Loyalty, LoyaltyBannerType} from '../../../core/models/payment-item.model';
import {CartStore} from '../../../core/stores/cart.store';
import {PaymentStore} from '../../../core/stores/payment.store';
import {Platform} from '@ionic/angular';
import { RestaurantStore } from '../../../core/stores/restaurant.store';

@Component({
  selector: 'app-loyalty-banner',
  templateUrl: './loyalty-banner.component.html',
  styleUrls: ['./loyalty-banner.component.scss'],
})
export class LoyaltyBannerComponent implements OnInit {
  @Input() withBorder = true;
  @Input() loyaltyBannerType: LoyaltyBannerType;
  public loyalty: Loyalty;

  private defaultPointName = {'one': 'loyalty point', 'other': 'loyalty points'};
  private cartBannerText = { title: `${this.capitalizeString(this.pointsName.other)} added!`, text: `Keep earning ${this.pointsName.other} to redeem rewards.` };
  private checkoutBannerText = { title: `${this.capitalizeString(this.pointsName.other)} earned on this order`, text: `Keep coming back to earn rewards!` };

  public get isMobile(): boolean {
    return this.platform.is('mobile') || this.platform.width() < 600;
  }

  public get circleWidth(): string {
    if (this.loyalty.pointsValue >= 1000) {
      return this.isMobile ? '11rem' : '10rem';
    } else if (this.loyalty.pointsValue >= 100) {
      return this.isMobile ? '9rem' : '8rem';
    } else {
      return this.isMobile ? '6rem' : '5rem';
    }
  }

  public get height(): string {
    return this.withBorder || this.isMobile ? '11rem' : '8.5rem';
  }

  public get pointsName(): any {
    if (this.restaurantStore && this.restaurantStore.loyaltyPointsName) {
      return this.restaurantStore.loyaltyPointsName;
    }
    return this.defaultPointName;
  }

  public get pointsValue(): string {
    return this.loyaltyBannerType === LoyaltyBannerType.CUSTOMER ? `${this.loyalty.pointsValue}` : `+${this.loyalty.pointsValue}`;
  }

  public get info(): any {
    switch (this.loyaltyBannerType) {
      case LoyaltyBannerType.CART: return this.cartBannerText;
      case LoyaltyBannerType.CHECKOUT: return this.checkoutBannerText;
      default: return this.cartBannerText;
    }
  }

  constructor(private cartStore: CartStore,
              private platform: Platform,
              private restaurantStore: RestaurantStore,
              private paymentStore: PaymentStore) { }

  ngOnInit() {
    if (this.loyaltyBannerType === LoyaltyBannerType.CUSTOMER) {
      this.paymentStore.customer$
        .subscribe( (customer) => {
          if (customer?.loyaltyPointsBalance != null) {
            const data = this.cartStore.loyalty;
            this.loyalty = new Loyalty([], data.pointsValue, data.pointsEnabled);
            this.loyalty.pointsValue = customer?.loyaltyPointsBalance || 0;
          }
        });
    } else {
      this.cartStore.loyalty$
        .subscribe( (loyalty) => {
          if (loyalty) {
            this.loyalty = loyalty;
          }
        });
    }
  }

  private capitalizeString(str: string) {
    return str.charAt(0).toUpperCase() + str.slice(1);
  }
}
